@layer design-system {
  .root {
    max-width: 270px;
  }

  .group {
    display: flex;
  }

  .buttonActive {
    color: var(--text-on-primary);
    background: var(--surface-primary);

    &:hover {
      background: var(--surface-primary);
    }
  }

  .buttonDisabled {
    &:disabled {
      color: var(--text-default);
      border: none;
    }
  }
}
